import React from 'react';
import tropic from './tropic';
import Intercom from 'react-intercom';
import config from 'config';
import PropTypes from 'prop-types';

import '@/scss/customizations.scss';

/*eslint-disable no-unused-vars*/
import * as bootstrap from 'bootstrap';
/*eslint-disable no-unused-vars*/

import '@/scss/main.scss';

const viewWrapper = (opts) => (view) => {

	class TropicViewHOC extends React.Component {
		constructor(props, context) {
			super(props, context);
			/* TODO well since we'll be performing a new fetch for
			each view, we can put the initial data in the ejs now too
			*/
			this.state = {
				initialFetchStatus: '',
			};
			this.startLoading = this.startLoading.bind(this);
			this.stopLoading = this.stopLoading.bind(this);

		}
		componentWillMount() {
			//Update GTM
			let meeting_id = getURLParam('meeting_id');
			if(meeting_id) {
				gtag('set', 'user_properties', {
					meeting_id
				});
			}
			if(this.props.appState.user && this.props.appState.user.user_id) {
				gtag('set', 'user_properties', {
					user_id: this.props.appState.user.user_id
				});
			}

			if (location.pathname != '/TransferTo') {
				gtag('event', 'page_view', {
					page_location: location.pathname,
					page_title: location.pathname.slice(1)
				});
			}

			if (opts.pageTitle) {
				document.title = opts.pageTitle;
			} else {
				document.title = 'Compass';
			}

			if(opts.fetchUrl){

				let fetchObj = {
					url: opts.fetchUrl,
					method: opts.method || 'GET'
				};

				this.setState({initialFetchStatus: 'fetching'});

				tropic.fetch(fetchObj).then(data => {
					this.setState({
						initialFetchStatus: 'success',
						viewData: data
					});
				}, error => {

					this.setState({
						initialFetchStatus: 'error',
						initialFetchError: error
					});
				});
			}
		}
		startLoading() {
			this.setState({loading: true});
		}
		stopLoading() {
			this.setState({loading: false});
		}
		_renderErrorModal() {
			return <div> show fetch error modal </div>;
		}
		_renderSpinner() {
			return <div> show spinner </div>;
		}

		render() {

			switch(this.state.initialFetchStatus) {
				case 'fetching': return <div>{"Loading..."}</div>;
				case 'error': return (
					<div>
						{`Error in initial fetch from ${opts.fetchUrl}: ${this.state.initialFetchError.toString()}`}
					</div>);
				default: {

					//should I use createElement in render?
					let viewComponent = React.createElement(view, {
						...this.props,
						viewData: this.state.viewData,
						loading: {
							start: this.startLoading,
							stop: this.stopLoading
						}
					});

					return (
						<div>
							{opts.enableIntercom && config.intercom.enabled !== false &&
								<Intercom appID={config.intercom.appId} email={this.props.appState.user.email}/>
							}
							{(this.state.loading) && this._renderSpinner()}
							{(this.state.asyncFetchStatus === 'error') && this._renderErrorModal()}
							{viewComponent}
						</div>
					);
				}
			}
		}
	}
	TropicViewHOC.propTypes = {
		appState: PropTypes.object
	};
	return TropicViewHOC;
};

const getURLParam = variableName => {
	// remove leading '?'
	const urlParamsString = location.search.slice(1);
	// parse query string into object
	const urlParams = new URLSearchParams(urlParamsString);
	return urlParams.get(variableName);
};

export {
	viewWrapper,
	getURLParam
};
